module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/spinner-white-941539eecb90783c448dc70560e5bf00.svg";